import { put } from 'redux-saga/effects';
import {
    CHANGE_GLOSSARY_MODAL_VISIBILITY,
    setGlossaryModalVisible
} from '../actions';

export function* changeGlossaryModalVisibility( action ) {
    const { isVisible } = action.payload;

    yield put( setGlossaryModalVisible( isVisible ) );
    yield put( CHANGE_GLOSSARY_MODAL_VISIBILITY.success() );
}